import { styleguideColors, styleguideColorsExtended } from '../../../core/tokens/styleguide';

/**
 * AdminCommon color seam — maps the 2026 Kai Styleguide tokens to the
 * semantic color names that AdminCommon components consume.
 *
 * Repointing this single file flips the entire AdminCommon surface
 * (buttons, fields, nav tabs, toggles, dropdowns) to the new design language.
 */
export const adminCommonColors = {
  /** Primary content surface — cards, inputs, dropdowns. */
  surface: styleguideColors.white,
  /** Muted surface — locked fields, disabled inputs, hover regions. */
  surfaceMuted: styleguideColorsExtended.sunken,

  /** Primary text — values, headings, active labels. */
  text: styleguideColors.ink,
  /** Secondary text — helper text, descriptions. */
  textSecondary: styleguideColorsExtended.textSecondary,
  /** Tertiary text — inactive labels, placeholder captions. */
  textTertiary: styleguideColorsExtended.textTertiary,
  /** Muted text — nav-tab secondary, metadata. */
  textMuted: styleguideColors.midtone,

  /** Standard hairline border. */
  border: styleguideColors.stroke,
  /** Focused / emphasized border. */
  borderFocus: styleguideColors.ink,

  /** Accent fill — selected toggle, active emphasis. */
  accentFill: styleguideColors.accent,
  /** Text on accent fill. */
  accentText: styleguideColors.ink,

  /** Error / destructive. */
  error: styleguideColors.error,
} as const;
